import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export let DeletePartnerThunk = createAsyncThunk(
	"Partners/DeletePartnerThunk",
	async (arg, ThunkApi) => {
		let { rejectWithValue } = ThunkApi;
		try {
			let res = await axios.delete(`/api/admin/partners/${arg?.id}`);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data.data);
		}
	}
);
